import React from 'react';
import './SchemaInfo.css';

const SchemaInfo = ({ userSchema }) => {
  const formatFieldName = (key) => {
    const fieldNames = {
      'purchaseReason': 'Purchase Reason',
      'purchaseBudget': 'Budget',
      'salary': 'Monthly Salary',
      'lifeStyleSummary': 'Lifestyle',
      'location': 'Preferred Location',
      'monthlyExpenses': 'Monthly Expenses',
      'monthlyInstallment': 'Preferred Monthly Payment',
      'apartmentType': 'Property Type',
      'deliveryDateRange': 'Timeline',
      'preferredDeveloper': 'Preferred Developer'
    };
    return fieldNames[key] || key;
  };

  const nonEmptyFields = Object.entries(userSchema).filter(([key, value]) => 
    value !== null && value !== undefined && value !== ''
  );

  if (nonEmptyFields.length === 0) return null;

  return (
    <div className="schema-info">
      <h4>📋 Information Collected:</h4>
      {nonEmptyFields.map(([key, value]) => (
        <div key={key} className="schema-item">
          {formatFieldName(key)}: {value}
        </div>
      ))}
    </div>
  );
};

export default SchemaInfo;
